export default __webpack_public_path__ + "static/media/ia-v1.2eff617e.png";